export default __webpack_public_path__ + "static/spotlight-anatomy-dark-9f47b5c0ee9fee2107e4c439a2c59396.png";